import React from 'react';
import LogoAnimate from '../../assets/images/LogoAnimate.svg';

/**
 * Searching State Component
 * Shows while ALICE is searching for candidates
 *
 * @param {Object} props
 * @param {string} props.query - User's search query
 * @param {string} props.jobTitle - Current job title
 */
export function SearchingState({ query, jobTitle }) {
  return (
    <div className="flex flex-col items-center justify-center h-full bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-12">
      {/* Animated Logo - Spinning/Pulsing */}
      <div className="mb-8 animate-spin-slow">
        <img
          src={LogoAnimate}
          alt="ALICE Searching"
          className="h-40 w-40 drop-shadow-lg"
        />
      </div>

      {/* Searching Message */}
      <div className="text-center max-w-2xl">
        <h3 className="text-3xl font-bold text-gray-800 mb-4 animate-pulse">
          Searching for Candidates...
        </h3>

        {jobTitle && (
          <div className="mb-4">
            <p className="text-lg text-gray-700 font-medium">
              for: <span className="text-blue-600 font-semibold">{jobTitle}</span>
            </p>
          </div>
        )}

        {query && (
          <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm border border-blue-200 p-4 mb-6">
            <p className="text-sm text-gray-600 mb-1">Your search query:</p>
            <p className="text-base text-gray-900 font-medium italic">
              "{query}"
            </p>
          </div>
        )}

        {/* Progress Indicators */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>

        <p className="text-gray-600 leading-relaxed">
          ALICE is analyzing thousands of resumes to find your perfect candidates.
          This usually takes 30-60 seconds.
        </p>
      </div>

      {/* Status Steps */}
      <div className="mt-8 w-full max-w-md bg-white/60 backdrop-blur-sm rounded-lg border border-blue-200 p-4">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center animate-pulse">
              <span className="text-white text-xs font-bold">✓</span>
            </div>
            <span className="text-sm text-gray-700">Analyzing job requirements</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center animate-pulse">
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
            <span className="text-sm text-gray-700 font-medium">Searching candidate database...</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center">
              <span className="text-gray-500 text-xs">3</span>
            </div>
            <span className="text-sm text-gray-500">Ranking and sorting results</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchingState;

